import {announce} from '@github-ui/aria-live'
import {useMutation, useQueryClient} from '@github-ui/react-query'

import {LABELS} from '../constants'
import {useSavedViewEndpoints} from '../contexts/SavedViewEndpointsContext'
import type {UpdateSavedViewResponse, UpdateSavedViewVariables} from '../types'
import {
  primeSavedViewCaches,
  type SavedViewMutationOptions,
  sendSavedViewMutationJson,
} from '../utils/saved-view-mutations'

export function useUpdateSavedViewMutation<TConfiguration = never>({owner, repo}: SavedViewMutationOptions) {
  const queryClient = useQueryClient()
  const {basePath} = useSavedViewEndpoints(owner, repo)

  return useMutation<UpdateSavedViewResponse<TConfiguration>, Error, UpdateSavedViewVariables<TConfiguration>>({
    mutationFn: ({id, ...body}) =>
      sendSavedViewMutationJson<UpdateSavedViewResponse<TConfiguration>>(
        `${basePath}/${encodeURIComponent(id)}.json`,
        {method: 'PUT', body},
        LABELS.views.updateError,
      ),
    onSuccess: ({savedView}) => primeSavedViewCaches({queryClient, owner, repo}, savedView),
    onError: () => announce(LABELS.views.updateError, {assertive: true}),
  })
}
